// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add_to_folders_dropdown-module__container--2eKnb{position:absolute;top:40px;width:430px;background:#fff;color:#616161;text-align:left;-webkit-box-shadow:0 1px 6px 0 rgba(0,0,0,0.2),0 0 0 1px rgba(0,0,0,0.08);-moz-box-shadow:0 1px 6px 0 rgba(0,0,0,0.2),0 0 0 1px rgba(0,0,0,0.08);box-shadow:0 1px 6px 0 rgba(0,0,0,0.2),0 0 0 1px rgba(0,0,0,0.08);z-index:101;font-weight:400;font-size:14px;line-height:21px;letter-spacing:0}@media screen and (max-width: 48em){.add_to_folders_dropdown-module__container--2eKnb{height:247px;width:290px;top:-247px}}\n", ""]);
// Exports
exports.locals = {
	"container": "add_to_folders_dropdown-module__container--2eKnb"
};
module.exports = exports;
